import SearchIcon from '@mui/icons-material/Search';

export const SearchIconMUI = SearchIcon;
